module.exports = __webpack_public_path__ + "media/images/inventory-07869119ff5ede44120bc156538e25ae.svg";